import React, { useState, useEffect } from "react";
import SalesbyTable from "./SalesbyTable";
import BarCharts from "../../../Dashboard/BarCharts";
import { Grid } from "@mui/material";
import DashDateRangeComponent from "../../../../reuseableComponents/DashDateRangeComponent";
import DateRangeComponent from "../../../../reuseableComponents/DateRangeComponent";
import { useSelector, useDispatch } from "react-redux";
import { useAuthDetails } from "../../../../Common/cookiesHelper";
import { fetchsystemAccessListData } from "../../../../Redux/features/SystemAccess/systemAccessSlice";
import PasswordShow from "../../../../Common/passwordShow";
import { ToastifyAlert } from "../../../../CommonComponents/ToastifyAlert";

function SalebyHourMain({ hide, setCSVData, setCSVHeader, setCSVFileName }) {
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const onDateRangeChange = (dateRange) => {
    setSelectedDateRange(dateRange);
  };

  const dispatch = useDispatch();
  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } = PasswordShow();
  const [timeloading, setTimeloading] = useState(false);
  const AllInSystemAccessState = useSelector((state) => state.systemAccessList);
  const { LoginGetDashBoardRecordJson, userTypeData } = useAuthDetails();
   
  let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
 
  const fetchSystemAccessList = () => {
    setTimeloading(true);
    try {
       let data = {
         merchant_id,
         ...userTypeData,
       };
       // systemAccessData is loaded globally in Main.js. Initial/failed state is
       // an array ([]); a successful load replaces it with an object. Only fetch
       // if it hasn't been loaded yet, otherwise reuse the already-loaded data.
       if (data && Array.isArray(AllInSystemAccessState.systemAccessData)) {
         dispatch(fetchsystemAccessListData(data));
       }
     } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      } else {
        ToastifyAlert(error?.message || error?.payload || "Something went wrong. Please try again.", "error");
      }
     }finally {
      setTimeloading(false);
    } 
   };
 
  useEffect(() => {
     fetchSystemAccessList();
   }, []);

  return (
    <>
      <Grid container sx={{ my: 2.5 }}>
        {hide ? (
          <DashDateRangeComponent onDateRangeChange={onDateRangeChange} timeComponent={false} 
          AllInSystemAccessState={AllInSystemAccessState} timeloading={timeloading}/>
        ) : (
          ""
        )}
      </Grid>

      <SalesbyTable
        selectedDateRange={selectedDateRange}
        setCSVData={setCSVData}
        setCSVHeader={setCSVHeader}
        setCSVFileName={setCSVFileName}
      />
    </>
  );
}

export default SalebyHourMain;
